import { Component, OnInit, OnDestroy, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../@core/service/api.service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseProductModel, BaseProductStatus, DownloadType, EBaseProductStatus } from '../../../@models/erp/baseProduct';
import { AcceleratorType, BusinessUnitUtil, CompilationTypeData, CountryCodes, MicaPaper } from '../../../@models/erp/compilationData';
import { MaterialModel } from '../../../@models/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FinishedProductModel } from '../../../@models/erp/finishedProduct';
import { AbstractProduct } from '../abstractProduct';
import { BusinessField, BusinessModel, BusinessUnitModel } from '../../../@models';
import { SocketService } from '../../../@core/service/socket.service';
import { CommonDialogComponent, NrkDialogButton, NrkDialogType } from '../shared/common-dialog/common-dialog.component';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { EWizardAction, ProductWizardComponent, WizardAction } from '../product-wizard/product-wizard.component';
import { mongoId } from '../../../@core/common/global';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { FinishedProductComponent } from '../finished-product/finished-product.component';

@Component({
  selector: 'ngx-erp-base-product',
  templateUrl: './base-product.component.html',
  styleUrls: ['./base-product.component.scss'],
})
export class BaseProductComponent extends AbstractProduct<BaseProductModel> implements OnInit, OnChanges {

  @Input() fromWizard: ProductWizardComponent = null;
  @Output() wizardAction = new EventEmitter<WizardAction>()
  @Input() baseProduct: BaseProductModel;

  items: BaseProductModel[] = [];
  selected: BaseProductModel;
  displayItems: BaseProductModel[] = [];

  micaPapers = MicaPaper;
  typeData = CompilationTypeData;
  mongoId = mongoId;

  countryOptions = CountryCodes.getOptions();
  
  // businessUnits: BusinessUnitModel[] = [];
  // businessUnitOptions: { id: string; name: string }[] = [];
  accelTypeOptions = [{id: null, name: ''}, ...AcceleratorType.getOptions()];
  micaPaperOptions = [{id: null, name: ''}, ...MicaPaper.getOptions()];
  // materials: MaterialModel[];
  // materialOptions: { id: string; name: string }[] = [];
  material = (m) => (this.data.materialOptions.find(s => (s.id === m )));
  finishedProducts: FinishedProductModel[];
  downloadType = DownloadType;
  isPreview = false;
  clonedFinishedProducts: { checked: boolean, fp: FinishedProductModel }[]; // FinishedProductModel[] = [];

  productName: string[] = [];
  materialName: string[] = [];
  businessName: string[] = [];
  isTDS: string[] = [];

  dirtyString = '';

  public search: string;
  public column: string;

  columnOptions = [
    { id: '', name: 'in all columns' },
    { id: 'name', name: 'Name', search: '' },
    { id: 'trial', name: 'Trial number', search: '' },
    { id: 'customer', name: 'Customer', search: '' },
    { id: 'supplier', name: 'Supplier', search: '' },
    // { id: 'businessUnit', name: 'Business Unit', search: '' },
    { id: 'material', name: 'Material', search: '' },
    { id: 'weight', name: 'Weight (g/m²)', search: '' }, // 'Total area\nweight (g/m²)' },
    { id: 'remark', name: 'Remark', search: '' },
    { id: 'code', name: 'Code', search: '' },
    { id: 'updatedAt', name: 'Updated', search: '' },
  ];
  columns = this.columnOptions.splice(1);

  statusOptions = BaseProductStatus.getOptions();
  statusFilterOptions = [{id: 0, name: 'all'}, ...BaseProductStatus.getOptions()];
  statusFilter = 0;

  buFilterOptions: { id: string, name: string }[]
  buFilter = null;

  // subscriptions: Subscription[] = [];

  productRouteToggled = false;

  bpPage: number;

  constructor(
    public api: ApiService,
    protected toastrService: NbToastrService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected dialogService: NbDialogService,
    protected socket: SocketService,
    public auth: AuthGuardService,
    public data: SharedDataService,
  ) {
    super(dialogService, api, auth, data);
  }

  ngOnInit() {
    this.auth.loadMe().then(async user => {
      this.readOnly = user.erpRoles.readOnlyProducts;

      await this.loadData();
      if (this.route.snapshot.queryParams['code'] && !this.productRouteToggled) {

        this.toggleSidebar(this.getCurrentItems(this.data.baseProducts).find(
          s => s.code === this.route.snapshot.queryParams['code']
        ));
        this.productRouteToggled = true;
      }

    });
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.baseProduct && changes.baseProduct.currentValue) {
      await this.loadData();
      this.toggleSidebar(this.baseProduct);
    }
  }

  async loadData(reload = false) {
    // return new Promise(resolve => {

    // this.subscriptions.forEach(s => s.unsubscribe());
    //   this.api.preloadBusiness(false).then(_businesses => {
    //     this.businesses = _businesses;
    //     this.businessOptions = _businesses.map(m => ({ id: m._id, name: m.name }));
    //   })

    //   this.subscriptions.push(this.api.reloadMaterials().subscribe(async _materials => {
    //     this.materials = _materials;

    //     this.materialOptions = _materials.map( m => ({ id: m._id, name: m.name }));

    //     this.subscriptions.push(this.api.reloadBusinessUnits().subscribe(_bu => {
    //       this.businessUnits = _bu;
    //       this.businessUnitOptions = _bu.map(m => ({ id: m._id, name: m.name }));
    //       this.buFilterOptions = BusinessUnitUtil.getBusinessUnitOptions(_bu, this.readOnly);
    //       this
    //     }));

    //     if (!reload) await this.loadItems();
    //     resolve(true);
    //   }));
    // })
    await this.data.reloadCompilationData();
    if (reload) {
      await Promise.all([
        this.data.reloadBusinessUnits(),
        this.data.reloadMaterials(),
        this.data.reloadBusinesses(),
      ]);
      await this.loadItems(true);
    } else {
      await Promise.all([
        this.data.loadBusinessUnits(),
        this.data.loadMaterials(),
        this.data.loadBusinesses(),
      ]);
      await this.loadItems();
    }
  }

  async loadItems(reload = false): Promise<void> {
    if (reload) {
      await this.data.reloadProducts();
    } else {
      await this.data.loadProducts();
    }
    this.buFilterOptions = BusinessUnitUtil.getBusinessUnitOptions(this.data.businessUnits, this.readOnly);
    this.items = this.data.baseProducts; // super.getItems(this.data.baseProducts);
    if (this.readOnly) {
      this.items = this.items.filter(f => !f.draft);
    }
    this.displayItems = this.getCurrentItems(this.items, true);
    this.displayItems.forEach(el => {
      this.productName[el._id] = this.getProductName(el); 
      this.materialName[mongoId(el.material)] = this.getMaterialName(mongoId(el.material));
      this.businessName[el.customer.id] = this.getBusinessName(el.customer.id);
      this.businessName[el.supplier.id] = this.getBusinessName(el.supplier.id);
      this.isTDS[el._id] = this.getTDS(el)?.checked;
      el.businessUnit = mongoId(el.businessUnit); this.data.businessUnits.find(f => mongoId(f) === mongoId(el.businessUnit));
    })
  }

  // getFinishedProducts(): FinishedProductModel[] {
  //   const fptable = [];
  //   const codes = [];
  //   if (this.finishedProducts) this.finishedProducts.sort((a, b) => a.version < b.version ? 1 : -1).forEach(el => {
  //     if (!codes.includes(el.code) && !el.draft) {
  //       codes.push(el.code);
  //       el['tmpName'] = this.removeVersionString(el.calcName);
  //       fptable.push(el);
  //     }
  //   });
  //   return fptable.sort((a, b) => a.code < b.code ? 1 : -1);
  // }

  getProductName(item: BaseProductModel, version: boolean = true): string {
    const name = item.name || 'undefined';
    return name + (version ? ` (${item.code}-${this.getVersionString(item)})` : '');
  }

  thicknessChanged(event) {
    if (!event) return
    if (!event.target) event = { target: { value: event } };
    if (event.key === 'Backspace' || event.key === 'Escape') {
      event.target.value = '';
    }
    const value = event.target.value = (event.target.value &&
      event.target.value.replace(/[^0-9]/g, '')).slice(event.target.value.length - 5).padStart(5,'0');
    let name = this.selected.name?.trim();
    const thick = this.selected.thickness;
    const re = new RegExp(`${thick}$`, 'g');
    name = name.match(re) ? name.replace(re, value) : name + ' ' + value;
    this.selected.name = event.target.value === '00000' ? name.replace(/ ?0+$/, '') : name;
    this.selected.thickness = event.target.value === '00000' ? null : event.target.value;
  }

  getMaterialName(mat) {
    if (mat) {
      return this.data.materials.find(f => mongoId(f) === mongoId(mat))?.name;
    }
  }

  getBusinessUnitName(buid: string) {
    if (buid) {
      const bu = this.data.businessUnits.find(f => f._id === mongoId(buid));
      return (bu && bu.name) || '';
    }
  }

  getTDS(item: BaseProductModel) {
    const tds = item.technicalDatasheets?.filter(f => f.checked);
    return tds && tds.length && tds[0];
  }

  async downloadTDS(item: BaseProductModel) {
    await this.api.downloadFile(this.getTDS(item));
  }

  setMaterialOptions(buAccounting: BusinessUnitModel) {
    const opts = this.data.materials
      .filter(f => f.businessUnit === mongoId(buAccounting))
      .map(m => ({ id: m._id, name: m.name }));
    if (opts) {
      this.data.materialOptions = [{ id: null, name: '' }, ...opts];
    }
    this.finishedProducts && this.finishedProducts.forEach(i => {
      const bu = this.data.businessUnits.find(f => f._id === mongoId(buAccounting))
      i.calcCode = bu.code && i.calcCode && i.calcCode.replace(/^./, bu.code);
    });
  }

  setMaterial(material: string) {
    this.selected.material = new MaterialModel();
    this.selected.material._id = material;
    this.finishedProducts && this.finishedProducts.forEach(i => {
      const mat = this.data.materials.find(f => f._id === material);
      if (mat.code) {
        i.calcCode = i.calcCode.replace(/^(.)-.../, '$1-' + this.data.materials.find(f => f._id === material).code);
      }
    });
  }

  isEnergy(item: BaseProductModel) {
    // TODO: return bu  by code;
    const bu = this.data.businessUnits.find(f => f._id === mongoId(item.businessUnit));
    return bu && bu.name.match(/energy materials/i);
  }

  async validate(item: BaseProductModel): Promise<boolean> {
    let valid: boolean = true;
    if (!item.name || item.name === '') {
      this.toastrService.danger('[Name] is required', 'Validation Error');
      valid = false;
    }
    if (!item.material) {
      this.toastrService.danger('[Material] is required', 'Validation Error');
      valid = false;
    }
    if (!item.businessUnit) {
      this.toastrService.danger('[Business Unit] is required', 'Validation Error');
      valid = false;
    }
    if (item.weight && (isNaN(item.weight) || item.weight <= 0)) {
      this.toastrService.danger('[weight] numeric value > 0 is required', 'Validation Error');
      valid = false;
    }
    if (!item.trial || item.trial === '') {
      this.toastrService.danger('[Trial nummer] is required', 'Validation Error');
      valid = false;
    }
    if (!item.changelog || item.changelog === '') {
      this.toastrService.danger('[Changelog comment] is required', 'Validation Error');
      valid = false;
    }
    return valid;
  }

  // edit() {
  //   this.locked = false;
  // }

  clearFilter() {
    this.columns.forEach(el => el.search = '');
    this.statusFilter = 0;
    this.buFilter = null;
  }

  filter(columns/* sort = false */) {
    this.displayItems = this.displayItems.map((item, index) => ({ item, index }))
      .sort((a, b) => {
        const ac = this.getItemString(a.item, this.sort.column);
        const bc = this.getItemString(b.item, this.sort.column);
        if (ac === bc) return a.index - b.index;
        if (typeof ac === 'number' && typeof bc === 'number') {
          return ac > bc ? this.sort.dir : -this.sort.dir;
        }
        return this.sort.dir * (''+ac).toLowerCase().localeCompare((''+bc).toLowerCase());
      })
      .map(({item}) => item);
    let ret = this.displayItems;
    this.columns.forEach(col => {
      const s = col.search.toLowerCase();
      if (col.search.length) {
        switch (col.id) {
          case 'businessUnit': ret = ret.filter(field =>
            (field.businessUnit && this.data.businessUnits
              && this.data.businessUnits.find(f =>
                f._id === mongoId(field.businessUnit) && f.name.toLowerCase().includes(s)
              )));
            break;
          case 'customer':
          case 'supplier': ret = ret.filter(field =>
            (field[col.id] && field[col.id].id
              && this.data.businesses.find(f => mongoId(f._id) === mongoId(field[col.id].id))
                .name.toLowerCase().includes(s)));
            break;
          case 'material': ret = ret.filter(field =>
            (field.material && field.material.name && field.material.name.toLowerCase().includes(s)));
            break;
          default:
            ret = ret.filter(field => this.filterItem(field, col.id, s));
        }
      }
    });
    ret = +this.statusFilter ? ret.filter(f => +f.status === +this.statusFilter) : ret.filter(f => f.status !== 5 /* filter templates*/);
    ret = this.buFilter && this.buFilter !== 'null' ? ret.filter(f => f.businessUnit === this.buFilter) : ret;
    return this.readOnly ? ret.filter(f => BusinessUnitUtil.readOnlyFilter(this.data.businessUnits, f.businessUnit)) : ret
  }

  getItemString(item, col) {
    switch (col) {
      case 'weight':
        return +item[col];
      case 'customer':
      case 'supplier':
        // console.log('get item string', item, item[col], this.data.businesses);
        const b = item[col] && item[col].id && this.data.businesses.find(f => f._id === mongoId(item[col].id))
        // console.log('get item string', item, item[col], b, this.data.businesses);
        return b && b.name && b.name.toLowerCase();
      case 'material':
        const mat = item[col] && this.data.materials.find(f => f._id === mongoId(item[col]));
        return mat && mat.name && mat.name.toLowerCase();
      case 'businessUnit':
        const bu = item[col] && this.data.businessUnits.find(f => f._id === mongoId(item[col]));
        return bu && bu.name && bu.name.toLowerCase();
      default: return item[col] ? item[col] : '';
    }
  }

  onSort(col) {
    super.onSort(col);
  }

  async create(item: BaseProductModel = null, clone = false, withFinishedProducts = false, silent = false) {
    let dlgData;
    if (withFinishedProducts) {
      dlgData = await this.showCloneDialog();
      if (! dlgData.success) return false;
    }
    if (!silent) super.create();
    if (item && clone) {
      this.selected = Object.assign({}, item);
    } else {
      this.selected = new BaseProductModel();
    }
    this.selected.version = 0;
    this.selected.draft = true;
    this.selected.customer = new BusinessField();
    this.selected.supplier = new BusinessField();
    if (this.fromWizard && this.fromWizard.compilation && this.fromWizard.compilation.type === CompilationTypeData.get('TOF').id) {
      this.selected.status = EBaseProductStatus.template;
    }
    // code is set in backend (this is only preview)!
    const code = this.items.length ?
      '' + (1 + this.items.map(m => +m.code || 0).reduce((a, b) => Math.max(a, b))) : '1';
    this.selected.code = [0,0,0,0].splice(code.length).join('') + code;
    super.lock(false);
    if (withFinishedProducts) {
      if (dlgData.customers[0]) this.selected.customer = dlgData.customers[0];
      if (dlgData.suppliers[0]) this.selected.supplier = dlgData.suppliers[0];
      this.finishedProducts.forEach(fp => {
        const fpClone = Object.assign({}, fp);
        fpClone.customers = dlgData.customers
        fpClone.suppliers = dlgData.suppliers
        this.clonedFinishedProducts.push({checked: true, fp: fpClone});
      })
    }
    this.finishedProducts = null;
  }

  showCloneDialog(): Promise<{success: boolean, customers: BusinessModel[], suppliers: BusinessModel[]}> {
    return new Promise(resolve => {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.cloneBaseProduct,
          businessOptions: this.data.businessOptions,
          customers: this.fromWizard.customer && [{ checked: true, id: mongoId(this.fromWizard.customer) }],
          suppliers: this.fromWizard.supplier && [{ checked: true, id: mongoId(this.fromWizard.supplier) }],
        },
      }).onClose.subscribe(ret => {
        if (ret.button && ret.button === NrkDialogButton.cancel) {
          resolve({ success: false, customers: null, suppliers: null });
        }
        resolve({ success: true, customers: ret.customers, suppliers: ret.suppliers });
      });
    });
  }

  async updateFinishedProducts(item: BaseProductModel) {
    // console.trace();
    if (this.finishedProducts && this.finishedProducts.length) {
      this.finishedProducts.forEach(async el => {
        el.product = item;
        await this.api.saveFinishedProduct(el);
      });
    }
  }

  handleError(err) {
    let msg = err.error?.errmsg || err.error?.message;
    console.error('error:', err);
    if (err.error.keyValue && err.error.code === 11000 && err.error.keyValue.code) {
      msg = `Document ${err.error.keyValue.code} version ${err.error.keyValue.version} already exists`;
    } else if (err.error.keyValue && err.error.code === 11000 && err.error.keyValue.trial) {
      msg = `Trial number ${err.error.keyValue.trial} already exists`;
    } else if (err.error.code === 11000 && err.error.errmsg.match(/trial/)) {
      msg = `Trial number ${err.error.errmsg.replace(/.*"(.*)".*/,'$1')} already exists`;
    }
    this.toastrService.danger(msg, 'Error');
  }


  async saveItem(item: BaseProductModel, draft: boolean = false): Promise<BaseProductModel> {
    // console.log('socket', this.socket);
    // this.socket.log('base product saved');
    item.trial = item.trial && item.trial.trim();
    if (item.trial && !item.trial.length) delete item.trial
    try {
      await this.saveChangelog(item);
      // console.log('save base product', item, draft);
      const id = (await this.api.saveBaseProduct(item))?._id;
      // console.log('saved base product', item, draft, id);
      this.toastrService.success(`BaseProduct '${item.name}' saved!`, 'Success');
      await this.loadItems(true);
      // item = await super.reload(item);
      // item._id = id;
      item = this.data.baseProducts.find(f => mongoId(f) === id);
      // console.log('reloaded base product', item, draft);
      if (!draft) {
        // update finished product to latest base product
        await this.updateFinishedProducts(item);
        // this.api.downloadBaseProductPDF(item);
      }
      if (this.clonedFinishedProducts && this.clonedFinishedProducts.length) {
        for (const fp of this.clonedFinishedProducts) {
          // console.log('cloned finished product', fp)
          fp.fp._id = null;
          fp.fp.draft = false;
          fp.fp.code = null;
          fp.fp.version = 1;
          fp.fp.product = item;
          if (item.status === EBaseProductStatus.template) fp.fp.status = item.status;
          if (fp.checked) await this.api.saveFinishedProduct(fp.fp);
        }
        this.clonedFinishedProducts = [];
        this.finishedProducts = await this.api.loadFinishedProductsOfBaseProduct(item);
        // console.log('finished products', this.finishedProducts);

      }
      return Promise.resolve(item);
    } catch (err) {
      this.handleError(err);
      this.locked = false;
      item.draft = true;
      return Promise.reject('save failed')
    }
    return item;
  }

  async cancelDraft(item: BaseProductModel) {
    if (item._id && item.draft) await this.api.deleteBaseProduct(item);
    super.cancelDraft(item);
  }

  async pdfPreview(item: BaseProductModel, type: DownloadType) {
    if (this.validate(item)) {
      if (!item._id) {
        item = await super.save(item, true);
      }
      this.api.downloadBaseProductPDF(item, type);
    }
  }

  async newFinishedProduct(item: BaseProductModel) {
    if (await super.canDismiss(item) && !this.fromWizard) {
      const product = item._id;
      this.router.navigate(
        ['pages/erp/finished-product'],
        { queryParams: {
          product: product,
          customer: item.customer && item.customer.id && JSON.stringify(item.customer),
          supplier: item.supplier && item.supplier.id && JSON.stringify(item.supplier),
        }}
      );
    }
  }
  async newFinishedProductWizard(item: BaseProductModel) {
    this.wizardAction.emit(new WizardAction(EWizardAction.newFinishedProduct, item));
  }

  async gotoFinishedProduct(item: FinishedProductModel) {
    if (await super.canDismiss(this.selected)) {
      if (this.fromWizard) {
        this.baseProduct = null;
        this.wizardAction.emit(new WizardAction(EWizardAction.showFinishedProduct, item));
      } else {
        this.router.navigate(
          ['/pages/erp/finished-product'],
          { queryParams: {code: item.code} }
        );
      }
    }
  }

  async select(baseProduct: BaseProductModel) {

    if (this.fromWizard && this.fromWizard.offerWizard) {
      const finishedProducts = await this.api.loadFinishedProductsOfBaseProduct(baseProduct);

      await this.create(baseProduct, true, false, true);
      let newBaseProduct = Object.assign({}, this.selected);
      // newBaseProduct.version = 0;
      // newBaseProduct.draft = true;
      // this.selected.customer = new BusinessField();
      // this.selected.supplier = new BusinessField();
      // // code is set in backend (this is only preview)!
      // const code = this.items.length ?
      //   '' + (1 + this.items.map(m => +m.code || 0).reduce((a, b) => Math.max(a, b))) : '1';
      // this.selected.code = [0,0,0,0].splice(code.length).join('') + code;
      newBaseProduct._id = null;
      newBaseProduct.trial = this.fromWizard.trialNumber;
      newBaseProduct.customer = { checked: true, id: mongoId(this.fromWizard.customer) }
      newBaseProduct.supplier = { checked: true, id: mongoId(this.fromWizard.supplier) }

      await this.data.reloadProducts();
      if (finishedProducts && finishedProducts.length) {
        this.finishedProducts = finishedProducts;
        this.clonedFinishedProducts = [];
        // this.finishedProducts = JSON.parse(JSON.stringify(finishedProducts));
        // this.clonedFinishedProducts = [];
        this.evalProducts();
        newBaseProduct = await this.saveItem(newBaseProduct, true);
        this.finishedProducts.forEach(fp => {
          fp.product = mongoId(baseProduct);
          // console.log('saved finished product', this.api.saveFinishedProduct(fp));
        })
        // this.finishedProducts = await this.api.loadFinishedProductsOfBaseProduct(baseProduct);
        this.baseProductPriceMatrix(baseProduct, newBaseProduct);
      } else {
        await this.saveItem(newBaseProduct, false);
        this.toastrService.danger('no finished products to clone');
      }
    } else {
      // console.log('select', baseProduct);
      super.select(baseProduct);
    }
  }

  evalProducts() {
    // let ct = 0;
    this.finishedProducts.forEach(fp => {
      // delete fp._id;
      // const code = this.data.finishedProducts.length ?
      //   '' + (1 + (ct++) + this.data.finishedProducts.map(m => +m.code || 0).reduce((a, b) => Math.max(a, b))) : '1';
      fp.code = null; // [0,0,0,0,0,0,0,0,0].splice(code.length).join('') + code;
      // fp.calcCode = 'n/a';
      fp.draft = true;
      fp.version = 1;
      fp.customers = [{ checked: true, id: mongoId(this.fromWizard.customer) }]
      fp.suppliers = [{ checked: true, id: mongoId(this.fromWizard.supplier) }]
      // const comp = new FinishedProductComponent(this.api, this.toastrService, this.route, this.router, this.dialogService, this.auth);
      // comp.baseProducts = this.data.baseProducts;
      // comp.businessUnits = this.data.businessUnits;
      // comp.getCalcCode(fp);
    });

  }

  async toggleSidebar(item: BaseProductModel) {
    if (!item || (this.fromWizard && this.fromWizard.offerWizard)) return;
    this.selected = item;
    this.clonedFinishedProducts = [];
    this.thicknessChanged(item.thickness);
    this.setMaterialOptions(item.businessUnit);
    this.finishedProducts = await this.api.loadFinishedProductsOfBaseProduct(item);
    if (item && !item.customer) item.customer = new BusinessField();
    if (item && !item.supplier) item.supplier = new BusinessField();

    super.toggleSidebar(item);
  }

  async toggleDisable(item: BaseProductModel) {
    item.disabled = !item.disabled;
    await this.api.toggleDisableBaseProduct(item.code, item.disabled);
  }

  genLineItemsFromFinishedProducts() {
    this.wizardAction.emit(new WizardAction(EWizardAction.genLineItemsFromFinishedProducts, { fp: this.finishedProducts, rows: null }));
  }

  baseProductPriceMatrix(baseProduct = this.selected, newBaseProduct = null) {
    this.wizardAction.emit(new WizardAction(EWizardAction.baseProductPriceMatrix, {
      baseProduct: baseProduct, finishedProducts: this.finishedProducts, newBaseProduct,
      customer: this.fromWizard && this.fromWizard.customer, supplier: this.fromWizard && this.fromWizard.supplier,
    }));
  }
}
